export default __webpack_public_path__ + "static/media/awards_second.dbf47fd3.svg";